export interface LoyaltyHeroBannerThemeInterface {
  smallImageUrl: string
  largeImageUrl: string
}

export const theme: LoyaltyHeroBannerThemeInterface = {
  smallImageUrl:
    'https://craftypixels.com/placeholder-image/375x108/ff0000/ffffff',
  largeImageUrl:
    'https://craftypixels.com/placeholder-image/746x200/ff0000/ffffff',
}
